import { useState } from "react";
import React from "react";
import NetsuiteLog from "./NetSuiteLog";
import NetSuiteDataMapping from "./NetSuiteDataMapping";

interface Props {
  teamId: number;
}

export default function NetsuiteTabs(props: Props) {
  const [activeTab, setActiveTab] = useState("dataMapping");

  return (
    <div className="panel bg-white dark:bg-stone-300 rounded-2xl shadow-md mb-4 p-6">
      <div className="flex border-b">
        <div
          className={`py-2 mr-4 cursor-pointer text-slate-800 text-sm ${
            activeTab === "dataMapping"
              ? "border-b-2 border-blue-500 font-medium"
              : "font-normal "
          }`}
          onClick={() => setActiveTab("dataMapping")}
        >
          Data Mapping
        </div>
        <div
          className={`py-2  mr-4 cursor-pointer ${
            activeTab === "logs"
              ? "border-b-2 border-blue-500 font-semibold"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("logs")}
        >
          Logs
        </div>
      </div>
      <div className="pt-4">
        {activeTab === "dataMapping" ? (
          <div>
            <NetSuiteDataMapping teamId={props.teamId} />
          </div>
        ) : (
          <NetsuiteLog />
        )}
      </div>
    </div>
  );
}
